import styled from "styled-components";

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 0.71px solid ${({ theme }) => theme.border.black10};
  border-radius: ${({ borderRadius }) => `${borderRadius}px`};
`;

export const CardContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const CardIllustrationContainer = styled.div`
  height: 105px;
  overflow: hidden;
  background-color: ${({ theme }) => theme.bg.atlassian};
  display: grid;
  border-top-left-radius: ${({ borderRadius }) => `${borderRadius}px`};
  border-top-right-radius: ${({ borderRadius }) => `${borderRadius}px`};
  place-content: space-evenly;
`;

export const CardBodyContainer = styled.div`
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-bottom-left-radius: ${({ borderRadius }) => `${borderRadius}px`};
  border-bottom-right-radius: ${({ borderRadius }) => `${borderRadius}px`};
  background-color: ${({ theme }) => theme.bg.card};
  padding: 14px;
  position: relative;
  box-sizing: border-box;
  gap: ${({ hasLabel }) => (hasLabel ? "10px" : "0px")};
`;

export const CardHeading = styled.h1`
  margin: 0;
  font-size: 20px;
  color: ${({ theme }) => (theme.name === "dark" ? "#fff" : "#0a326c")};
  font-weight: 500;
  max-width: 80%;
`;

export const CardParagraph = styled.p`
  margin: 0;
  color: ${({ theme }) => (theme.name === "dark" ? "#ffffff" : "#0a326c")}80;
  font-size: 14px;
  line-height: 18px;
  white-space: pre-wrap;
`;

export const CardArrowContainer = styled.div`
  position: absolute;
  top: 16px;
  right: 14px;
`;

export const CardLabel = styled.span`
  background: ${({ background }) => background};
  color: ${({ color }) => color};
  border-radius: 9999px;
  padding: 5px 10px;
  font-size: 12px;
`;
